import * as lscache from 'lscache';
import React from 'react';
import ReactDOM from 'react-dom';
import App from './App';
import './index.scss';
import * as serviceWorker from './serviceWorker';
import { checkAndClearCache } from './util/helper';

// Configure the `lscache` unit-of-measure for expiration time which will be used in code hereinafter
// (1000 means each unit will be 1000ms i.e. 1 second)
lscache.setExpiryMilliseconds(1000);

// Clear Cache if needed
checkAndClearCache();

ReactDOM.render(<App />, document.getElementById('root'));

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
